export default __webpack_public_path__ + "static/media/chevron_left.9d911cf6.svg";